module.exports = __webpack_public_path__ + "images/b797e08.png";